<div class="flex justify-between content-center items-center mb-6 w-full">
  <div class="text-neutral-700 mt-6">
    <h1 class="text-7 tablet:text-8 font-medium pb-2">Good {{getTimeOfDay()}} {{dashboardInfo?.applicantName}}</h1>
    <p class="mb-6 text-4 leading-24">Below, you'll find all your interview details with {{dashboardInfo?.companyName}}.</p>
  </div>
  <img class="hidden w-[105px] tablet:block" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/clipart/calender.svg" alt="Calender">
</div>

<div class="text-neutral-500 text-2 leading-18 mb-4" *ngIf="upcomingMeetings.length">
  Upcoming Interviews
</div>
<div *ngFor="let meeting of upcomingMeetings">
  <interview-dashboard-card-pending
    *ngIf="meeting.status === InterviewStatus.TENTATIVE"
    [meeting]="meeting"
    [dashboardInfo]="dashboardInfo"
    (onViewDetailsClick)="viewInterviewDetails($event)">
  </interview-dashboard-card-pending>
  <interview-dashboard-card-confirmed
    *ngIf="meeting.status === InterviewStatus.ACCEPTED"
    [dashboardInfo]="dashboardInfo"
    [meeting]="meeting"
    (onClickViewDetails)="viewInterviewDetails($event)">
  </interview-dashboard-card-confirmed>
  <interview-dashboard-card-cancelled
    *ngIf="meeting.status === InterviewStatus.CANCELLED || meeting.status === InterviewStatus.DECLINED"
    [dashboardInfo]="dashboardInfo"
    [meeting]="meeting">
  </interview-dashboard-card-cancelled>
</div>

<div class="text-neutral-500 text-2 leading-18 mb-4" *ngIf="pastMeetings.length">
  Past Interviews
</div>
<div *ngFor="let meeting of pastMeetings">
  <interview-dashboard-card-pending
    *ngIf="meeting.status === InterviewStatus.TENTATIVE"
    [meeting]="meeting"
    [dashboardInfo]="dashboardInfo"
    (onViewDetailsClick)="viewInterviewDetails($event)">
  </interview-dashboard-card-pending>
  <interview-dashboard-card-confirmed
    *ngIf="meeting.status === InterviewStatus.ACCEPTED"
    [dashboardInfo]="dashboardInfo"
    [meeting]="meeting"
    (onClickViewDetails)="viewInterviewDetails($event)">
  </interview-dashboard-card-confirmed>
  <interview-dashboard-card-cancelled
    *ngIf="meeting.status === InterviewStatus.CANCELLED || meeting.status === InterviewStatus.DECLINED"
    [dashboardInfo]="dashboardInfo"
    [meeting]="meeting">
  </interview-dashboard-card-cancelled>
</div>
